import { render, staticRenderFns } from "./LoginM.vue?vue&type=template&id=4f5e5a54&scoped=true&"
import script from "./LoginM.vue?vue&type=script&lang=ts&"
export * from "./LoginM.vue?vue&type=script&lang=ts&"
import style0 from "./LoginM.vue?vue&type=style&index=0&id=4f5e5a54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e5a54",
  null
  
)

export default component.exports